import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportEntradaProdutoUseCase } from "../../../presentation/useCases/read/get_report_entrada_produto_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";


export class GetReportEntradaProdutoUseCase implements IGetReportEntradaProdutoUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportEntradaProduto(
    requiredMimeType: ReportMimeType | null,
    IdUsuario: number,
    Fornecedores?: number[],
    Produtos?: number[],
    NumeroNotaFiscal?: string | null,
    CentroCustos?: number[],
    DataInicio?: Date | null,
    DataFinal?: Date | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportEntradaProduto(
      requiredMimeType, IdUsuario ,Fornecedores, Produtos, NumeroNotaFiscal, CentroCustos, DataInicio, DataFinal
    );

    if (requiredMimeType !== "text/html") {
      const date = new Date().toISOString();
      const arquivoData = response.bytes;
      const arquivoNome =
        `EntradaProduto_${date}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
